import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import { handle_checkout_realtime_ticket_purchase } from "@/services/realtimeEventSecondHelper";

export default {
  components: {
    HomeNavBar,
  },
  mounted() {
    this.token_exists = get_token();
    this.fetchOrder();
    this.user_details = get_user_details();

    this._realtime_event_handler = (evt) => this.handle_realtime_event(evt);
    window.addEventListener("realtime:event", this._realtime_event_handler);
  },
  beforeUnmount() {
    if (this._realtime_event_handler) {
      window.removeEventListener("realtime:event", this._realtime_event_handler);
      this._realtime_event_handler = null;
    }
    if (this.reservation_timer) {
      window.clearInterval(this.reservation_timer);
    }
  },

  data() {
    return ({
      token_exists: false,
      order: null,
      is_order_loading: true,
      order_load_error: "",
      payfast: process.env.VUE_APP_PAYFAST_URL,
      user_details: {
        user_id: "",
      },
      reservation_seconds: 0,
      reservation_timer: null,
      is_cancelling: false,
    });
  },
  computed: {
    reservation_expired() {
      return this.order?.payment_status !== "COMPLETE"
        && this.reservation_seconds <= 0;
    },
    reservation_time_remaining() {
      const minutes = Math.floor(this.reservation_seconds / 60);
      const seconds = this.reservation_seconds % 60;
      return `${minutes}:${String(seconds).padStart(2, "0")}`;
    },
  },
  methods: {
    handle_realtime_event(event) {
      handle_checkout_realtime_ticket_purchase(this, event);
    },
    getToken() {
      return get_token();
    },

    confirm_checkout_cancellation() {
      return Swal.fire({
        title: "Cancel checkout?",
        text: "Your reserved tickets will be released for other customers.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Release tickets",
        cancelButtonText: "Continue checkout",
        confirmButtonColor: "var(--primary-color)",
      });
    },

    get_reserved_ticket_instance_ids() {
      return (this.order?.items || []).flatMap(
        (item) => (item.instances || []).map((instance) => instance.id),
      );
    },

    finish_checkout_cancellation() {
      if (this.reservation_timer) {
        window.clearInterval(this.reservation_timer);
        this.reservation_timer = null;
      }
      this.$router.push("/view_events");
    },

    show_checkout_cancellation_error(xhr) {
      this.is_cancelling = false;
      Swal.fire({
        title: "Could not cancel checkout",
        text: xhr.responseJSON?.message || "Please try again.",
        icon: "error",
      });
    },

    async cancel_checkout() {
      if (this.is_cancelling) return;

      if (this.reservation_expired) {
        this.finish_checkout_cancellation();
        return;
      }

      const confirmation = await this.confirm_checkout_cancellation();
      if (!confirmation.isConfirmed) return;

      const ticket_instance_ids = this.get_reserved_ticket_instance_ids();
      if (!ticket_instance_ids.length) {
        this.finish_checkout_cancellation();
        return;
      }

      this.is_cancelling = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/cancel_ticket_order/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          order_id: this.order.id,
          ticket_instance_ids,
        }),
        success: () => this.finish_checkout_cancellation(),
        error: (xhr) => this.show_checkout_cancellation_error(xhr),
      });
    },

     formatDateTime(datetime) {
    return new Date(datetime).toLocaleString();
  },

  completeEventPayment() {
    if (!this.order || !this.order.id) {
        Swal.fire({
          title: 'Order not found.',
          text: 'Please refresh and try again.',
          icon: 'warning',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
    }
    if (this.reservation_expired) {
      Swal.fire({
        title: "Ticket reservation expired",
        text: "Return to the event and select the tickets again.",
        icon: "warning",
      });
      return;
    }

    const order_id = this.$route.params.order_id;
    $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_payfast_event_payment/`,
        method: 'POST',
        data: JSON.stringify({
            order_id: order_id
        }),
        headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
        },
        success: (response) => {
                    if (response.success) {
                      var data_array = response.data_array;
                      var form = $('#payment_form');
                      for (var [key, value] of Object.entries(data_array)) {
                        var input = $('#input_clone').clone();
                        input.attr('name', key);
                        input.attr('value', value);  // Accessing value without square brackets
                        input.removeAttr('id');
                        input.removeClass('d-none');
                        form.append(input);
                    }
                      Swal.fire({
                          title: 'Success',
                          icon: 'success',
                          text: "Redirecting to PayFast in a few seconds don't close this page",
                          showConfirmButton: false,
                          position: 'bottom-end',
                          timer: 3000,
                          toast: true
                      })
                      form.submit();
                  }
                  },
        error: (error) => {
            console.error('AJAX error:', error);
            Swal.fire({
              title: 'Error',
              text: 'Payment failed. Please try again later.',
              icon: 'error',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
        }
    });
},

    fetchOrder() {
      const order_id = this.$route.params.order_id;

      this.is_order_loading = true;
      this.order_load_error = "";

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_purchase_order/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        data: {
          order_id: order_id
        },
        success: (response) => {
          this.order = response.order_data;
          this.is_order_loading = false;
          this.start_reservation_timer();
        },
        error: (xhr) => {
          console.error("Failed to fetch order:", xhr.responseText);
          this.order = null;
          this.is_order_loading = false;
          this.order_load_error = xhr.responseJSON?.message
            || "We could not load this order. Please refresh and try again.";
        },
      });
    },
    update_reservation_time() {
      const expires_at = new Date(this.order?.reservation_expires_at).getTime();
      this.reservation_seconds = Number.isFinite(expires_at)
        ? Math.max(0, Math.ceil((expires_at - Date.now()) / 1000))
        : 0;
    },
    start_reservation_timer() {
      if (this.reservation_timer) {
        window.clearInterval(this.reservation_timer);
      }
      this.update_reservation_time();
      this.reservation_timer = window.setInterval(
        this.update_reservation_time,
        1000,
      );
    },
  }
}
